import { useBasic, BasicProvider } from "./AuthContext";
import { useLiveQuery as useQuery } from "dexie-react-hooks";

// Re-export from AuthContext
export { useBasic, BasicProvider, useQuery }

// Type exports
export type { 
    AuthConfig, 
    BasicStorage, 
    LocalStorageAdapter, 
    BasicProviderProps,
    BasicContextType,
    AuthResult
} from "./AuthContext"

// Core DB exports
export type { 
    DBMode, 
    BasicDB, 
    Collection, 
    RemoteDBConfig,
    AuthError
} from "./core/db"

export { RemoteDB, RemoteCollection, RemoteDBError, NotAuthenticatedError } from "./core/db"

// Storage utilities
export { STORAGE_KEYS } from "./utils/storage"